import { type as accountType } from '@/iam/account';
import { scope } from '@/iam/scope';

export default {
  CONNECT_ACCOUNT: {
    accountTypes: [
      accountType.SERVICE_PROVIDER,
      accountType.CUSTOMER,
      accountType.CLIENT,
    ],
  },
  DOWNLOAD_POST_IMPORT_FILE: {
    accountTypes: [accountType.SERVICE_PROVIDER],
  },
  IMPORT_POSTS: {
    scope: scope.POST_IMPORT_CREATE,
  },
  VIEW_POST_IMPORT_FILE_NAME: {
    accountTypes: [accountType.SERVICE_PROVIDER],
  },
};
